import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router';
import ErrorImage from '../images/error.png';
import React from 'react';

export function describeError(status: string | null, message: string | null) {
  const code = status && Number(status) !== 0 ? `Status ${status}` : null;
  return [code, message || 'Unknown error'].filter(Boolean).join(' · ');
}

export default function ErrorPage() {
  const urlSearchParams = new URLSearchParams(useLocation().search);
  const details = describeError(urlSearchParams.get('status'), urlSearchParams.get('message'));

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: { xs: 2, sm: 6 }, px: 2 }}>
      <Paper variant="outlined" sx={{ maxWidth: 480, width: '100%', p: { xs: 3, sm: 4 }, borderRadius: 3, textAlign: 'center' }}>
        <Box component="img" src={ErrorImage} alt="" sx={{ width: 180, height: 180, objectFit: 'contain' }} />
        <Typography component="h1" sx={{ fontSize: '1.4rem', fontWeight: 700, color: '#007ca3', mt: 1 }}>
          Something went wrong
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          Please try again. If it keeps happening, sign out and back in, or let us know.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} justifyContent="center" sx={{ mt: 3 }}>
          <Button variant="contained" component={RouterLink} to="/dashboard">
            Back to dashboard
          </Button>
          <Button variant="outlined" component={RouterLink} to="/support">
            Report this problem
          </Button>
        </Stack>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 3, fontFamily: 'monospace' }}>
          {details}
        </Typography>
      </Paper>
    </Box>
  );
}
